import { render } from "./PersonalProfilePage.vue?vue&type=template&id=666733be&scoped=true"
import script from "./PersonalProfilePage.vue?vue&type=script&lang=js"
export * from "./PersonalProfilePage.vue?vue&type=script&lang=js"

import "./PersonalProfilePage.vue?vue&type=style&index=0&id=666733be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666733be"]])

export default __exports__